
import { AppState, ReduxAction } from "@declarations"
import { Actions } from "../actions";
export const UIStateReducers = (state: AppState.UIStates, { type, payload }: ReduxAction): AppState.UIStates => {

    if (type === Actions.SET_OVERVIEW_WAIT_STATE) return { ...state, waitingOverviewData: !!payload, pageNotFound: false }
    if (type === Actions.SET_PERIODIC_DATA_WAIT_STATE) return { ...state, waitingPeriodicData: !!payload, pageNotFound: false }
    if (type === Actions.SET_NOT_FOUND) return { ...state, pageNotFound: !!payload, }
    return state;
}